export const Container = ({ className = "", children, ...props }) => (
  <div className={`mx-auto w-full max-w-[1280px] px-6 md:px-10 ${className}`} {...props}>
    {children}
  </div>
);

export default Container;
